/* eslint-disable import/no-cycle */
import { CardType } from './Card';
import { IEmployee } from './Employee';
import { IHoldbackFixed, IHoldbackPercent } from './Holdback';
import { AcceptancePaymentSetStatus, IPaymentSet } from './PaymentSet';

export enum AcceptanceFeeCollectionMethod {
  ACH = 'ach',
  HOLDBACK = 'holdback',
}

export enum AcceptancePaymentMethod {
  CARD = 'card',
  APPLE_PAY = 'apple_pay',
}

export enum AcceptancePayoutStatus {
  FAILED = 'failed',
  PAID = 'paid',
  PENDING = 'pending',
}

interface IAcceptancePaymentFees {
  collectionMethod: AcceptanceFeeCollectionMethod;
  fixed: number;
  percent: number;
  total: number;
}

interface IAcceptancePaymentPayor {
  userId: string;
  name: string;
  email: string;
  last4: string;
  network: CardType;
}

export interface IAcceptancePayment {
  id: string;
  amount: number;
  fees: IAcceptancePaymentFees;
  employee: IEmployee;
  siteId: string;
  payor: IAcceptancePaymentPayor;
  currency: string;
  paymentDate: string;
  paymentMethod: AcceptancePaymentMethod;
  paymentSetId: string;
  status: AcceptancePayoutStatus;
  submittedAt: string;
  paidAt: string;
  createdAt: string;
  updatedAt: string;
}

export interface IAcceptancePayout {
  amount: number;
  employee: IEmployee;
  payments: number;
  holdbackAmount?: number;
  notes?: string;
}

export interface IAcceptancePaymentSetSummary {
  id: string;
  paymentDate: string;
  paymentId?: string;
  createdAt: string;
  siteId: string;
  status: AcceptancePaymentSetStatus;
  totals: { amount: number; employees: number; payments: number; net: number; fees: number };
  updatedAt: string;
}

export interface IAcceptancePaymentStats {
  count: number;
  gross: number;
  net: number;
  fees: {
    fixed: number;
    percent: number;
    total: number;
  };
}

interface ITipAcceptancePaymentSetTotals {
  amount: number;
  employees: number;
  payments: number;
  fees?: number;
  net: number;
  holdbacks?: number;
}

export interface ITipAcceptancePaymentSet {
  id: string;
  paymentDate: string;
  siteId: string;
  status: AcceptancePaymentSetStatus;
  totals: ITipAcceptancePaymentSetTotals;
  summary?: IPaymentSet;
  error?: string[];
  paymentId?: string;
  createdAt: string;
  updatedAt: string;
}

export interface ITipAcceptancePaymentSetPayouts extends ITipAcceptancePaymentSet {
  payouts: IAcceptancePayout[];
}

export interface ITipAcceptancePaymentSetRequestPayload {
  siteId: string;
  paymentSetId: string;
  siteHoldbacks: IHoldbackFixed | IHoldbackPercent;
}
